import React from 'react'
import classNames from 'classnames'
import {withToggles} from 'startlibs/lib/hocs'
import {smoothScroll} from 'startlibs/lib/lib'

const KEY_IMAGES_PANEL_FIXED_TOP = 160
const KEY_IMAGES_COMPACT_PANEL_FIXED_TOP = 40

@withToggles('expandedPanel','panel')
export class KeyImagesPanel extends React.PureComponent {
  keyImagesPanel
  keyImagesPlaceholder

  componentDidMount() {
    window.addEventListener('scroll', this.refreshPanelPositioning)
    this.refreshPanelPositioning(true)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.refreshPanelPositioning)
  }

  componentDidUpdate(oldProps) {
    if (!oldProps.reportKeyImages.order.length && this.props.reportKeyImages.order.length) {
      this.refreshPanelPositioning(true)
      this.props.expandedPanel.open()
    }
  }

  refreshPanelPositioning = (expand,forceExpand) => {
    const bottom = window.innerHeight - this.keyImagesPlaceholder.getBoundingClientRect().top
    const shouldBeFixed = bottom < (this.props.expandedPanel.isOpen ? KEY_IMAGES_PANEL_FIXED_TOP : KEY_IMAGES_COMPACT_PANEL_FIXED_TOP )
    if (this.props.panel.isOpen !== shouldBeFixed) {
      this.props.panel.toggle()
      if (expand && this.props.reportKeyImages.order.length) {
        this.props.expandedPanel.open()
      }
    }
  }

  setKeyImagesRef = (ref) => this.keyImagesPanel = ref
  setKeyImagesPlaceholder = (ref) => this.keyImagesPlaceholder = ref

  errorsAnchor
  setErrorAnchor = e => this.errorsAnchor = e
  scrollToErrors = () => {
    smoothScroll(this.errorsAnchor)
  }


  render() {
    const {panel, expandedPanel, isChangingTemplate, dragging, KeyImages} = this.props
    return <div className="attachments-page-container">
      <div ref={this.setKeyImagesRef} className={classNames('report-page attachments-page', {
        'compact-panel': !expandedPanel.isOpen,
        'expanded-panel': expandedPanel.isOpen,
        loading: isChangingTemplate,
        'fixed-panel': panel.isOpen,
        'is-panel':true,
        'hide-below': panel.isOpen && dragging.isOpen
      })}>
        {KeyImages({
          scrollToErrors:this.scrollToErrors,
          openCompactPanel:panel.isOpen && expandedPanel.open,
          toggleCompactPanel:panel.isOpen && expandedPanel.toggle,
          isPanel:panel.isOpen
        })}
      </div>
      <div className={'report-page attachments-page invisible'} ref={this.setKeyImagesPlaceholder}>
        {KeyImages({isPlaceholder:true})}
      </div>
      <span ref={this.setErrorAnchor}/>
    </div>
  }

}


// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/keyImages/KeyImagesPanel.jsx